<template>
  <div class="card">
    <div class="card-body">
      <div class="row m-2">
        <div class="col-12 p-l-0 title">
          <img src="/theme/icons/events.svg" class="m-r-20">
          <span>ВІДГУКИ О КНИЖКАХ</span>
        </div>
      </div>
      <template v-if="reviews.data.length > 0">
        <div v-for="review in reviews.data" class="story"> <!--:class="story.new ? 'story-new' : 'story'"-->
          <div>
            <template>
              <h6>{{ review.description.title }}</h6>
              <a :href="'/library/description/' + review.description_id + '#reviews'">
                  {{ review.reader.fullname }}:
                  {{ review.text }}
              </a>
            </template>
          </div>
          <div class="created text-right">
                <span class="float-left"><i class="mdi mdi-thumb-up-outline"></i> {{review.likes}} </span>
                {{ moment(review.created_at).format("YYYY-MM-DD hh:mm:ss") }}
          </div>
        </div>
        <div v-if="reviews.last_page != reviews.current_page" class="m-t-20 text-center" @click="getReviews()">
          <img src="/theme/icons/more-circle.svg">
        </div>
      </template>
      <template v-else>
        <p>Відгуків немає</p>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "DescriptionReviews",
  data() {
    return {
      reviews: {data:[]},
      sort: false,
      page: 0,
      total: 0,
    }
  },
  mounted() {
    this.getReviews();
  },
  methods:{
    getReviews: function() {
      this.page++;
      axios.get('/library/reviews/get_list?page='+ this.page)
        .then(response => {
          if (this.page > 1) {
            this.reviews.data = this.reviews.data.concat(response.data.data);
          } else {
            this.reviews = response.data;
            this.total = response.data.total;
          }
        })
    },
    moment: function (date) {
      return moment(date);
    },
  },
}
</script>

<style scoped>
  .created{
    color: #A7AFBA;
  }
  .story{
    border-radius: 8px;
    border: 1px solid #E5E5E5;;
    margin-top: 20px;
    padding:10px;
    font-size:14px;
    position: relative;
  }

  .story::before, .story::after {
    content: '';
    position: absolute;
    left: 20px; bottom: -10px;
    border: 5px solid transparent; border-left: 5px solid #E5E5E5; border-top: 5px solid #E5E5E5;
  }
  .story::after {
    left: 21px;
    border: 5px solid transparent; border-left: 3px solid white; border-top: 5px solid white;
  }
</style>
